import { render } from "./TagInput.vue?vue&type=template&id=2c3575e8&scoped=true"
import script from "./TagInput.vue?vue&type=script&lang=js"
export * from "./TagInput.vue?vue&type=script&lang=js"

import "./TagInput.vue?vue&type=style&index=0&id=2c3575e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3575e8"]])

export default __exports__